export enum adminApplicantsDetailTypes {
    FETCH_ADMIN_APPLICANTS_DETAIL_REQUEST = "FETCH_ADMIN_APPLICANTS_DETAIL_REQUEST",
    FETCH_ADMIN_APPLICANTS_DETAIL_SUCCESS = "FETCH_ADMIN_APPLICANTS_DETAIL_SUCCESS",
    FETCH_ADMIN_APPLICANTS_DETAIL_FAILURE = "FETCH_ADMIN_APPLICANTS_DETAIL_FAILURE",
  }